// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"49a7470d","215":"9fdf7035","306":"678e17af","321":"bdf2a480","323":"eb27828c","436":"e8b1af3a","664":"acad2652","841":"c1e829ae","850":"461b0bf7","976":"24402800","979":"a2bbc496"}[chunkId] + ".chunk.js";
};